import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import Tabs from "./../";
import Panel from "nav-frontend-paneler";
import Alertstripe from "nav-frontend-alertstriper";
export const _frontmatter = {
  "ingress": "Tabs er en meny som gir brukeren mulighet til å bytte mellom lagvis inndelt innhold."
};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Example = makeShortcode("Example");
const InlineCode = makeShortcode("InlineCode");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <nav {...{
      "className": "table-of-contents"
    }}><ol parentName="nav" {...{
        "className": "toc-level toc-level-1"
      }}><li parentName="ol" {...{
          "className": "toc-item toc-item-h2"
        }}><a parentName="li" {...{
            "className": "toc-link toc-link-h2",
            "href": "#normal"
          }}>{`Normal`}</a></li><li parentName="ol" {...{
          "className": "toc-item toc-item-h2"
        }}><a parentName="li" {...{
            "className": "toc-link toc-link-h2",
            "href": "#kombinasjon-med-panel"
          }}>{`Kombinasjon med panel`}</a></li><li parentName="ol" {...{
          "className": "toc-item toc-item-h2"
        }}><a parentName="li" {...{
            "className": "toc-link toc-link-h2",
            "href": "#kompakt"
          }}>{`Kompakt`}</a></li></ol></nav>
    <h2 {...{
      "id": "normal"
    }}>{`Normal`}</h2>
    <Example mdxType="Example">
  <Tabs tabs={[{
        label: "Første"
      }, {
        label: "Andre"
      }, {
        label: "Tredje"
      }]} onChange={() => {}} mdxType="Tabs" />
    </Example>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`<Tabs
  tabs={[{ label: "Første" }, { label: "Andre" }, { label: "Tredje" }]}
  onChange={() => {}}
/>
`}</code></pre>
    <h2 {...{
      "id": "kombinasjon-med-panel"
    }}>{`Kombinasjon med panel`}</h2>
    <p>{`Komponenten passer fint i kombinasjon med `}<a parentName="p" {...{
        "href": "/components/panel"
      }}>{`Panel`}</a>{`, hvor normal variant bør plasseres
utenfor og langs øverste kant av panelet.`}</p>
    <Alertstripe type="info" mdxType="Alertstripe">
  Inntil videre må du manuelt håndtere visning av riktig panel-innhold når aktiv
  tab endres. Du må også skru av
  <InlineCode className="inline" mdxType="InlineCode">border</InlineCode> og <InlineCode className="inline" mdxType="InlineCode">
    border-radius
  </InlineCode> langs toppen av panelet. Vi jobber med å lage en mer avansert <InlineCode className="inline" mdxType="InlineCode">
    TabPanel
  </InlineCode> komponent som er tenkt å både fikse disse stilene for deg, og håndtere
  automatisk visning av riktig panel-innhold avhengig av aktiv tab.
    </Alertstripe>
    <Example mdxType="Example">
  <Tabs tabs={[{
        label: "Første"
      }, {
        label: "Andre"
      }, {
        label: "Tredje"
      }]} onChange={() => {}} mdxType="Tabs" />
  <Panel border style={{
        borderTop: 0,
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0
      }} mdxType="Panel">
    Innhold her.
  </Panel>
    </Example>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`<Tabs
    tabs={[
        {"label": "Første"},
        {"label": "Andre"},
        {"label": "Tredje"}
    ]}
    onChange={() => {}}
/>
<Panel border style={{borderTop:0, borderTopLeftRadius: 0, borderTopRightRadius: 0}}>
    Innhold her.
</Panel>
`}</code></pre>
    <h2 {...{
      "id": "kompakt"
    }}>{`Kompakt`}</h2>
    <Example mdxType="Example">
  <Tabs tabs={[{
        label: "Første"
      }, {
        label: "Andre"
      }, {
        label: "Tredje"
      }]} onChange={() => {}} kompakt mdxType="Tabs" />
    </Example>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`<Tabs
  tabs={[{ label: "Første" }, { label: "Andre" }, { label: "Tredje" }]}
  onChange={() => {}}
  kompakt
/>
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      